{
  "z11-comparison-court": {"perspective":[240,900,0.96,1.08],"ground":[768,544],"haze":[126,128],"fog":0.035,"desaturation":0.08,"lift":[8,10,12]},
  "z12-white-joint": {"perspective":[200,900,0.92,1.06],"ground":[736,512],"haze":[1024,132],"fog":0.04,"desaturation":0.14,"lift":[14,15,17]}
}
